let languageCode = 'ht';
module.exports = {
	languageCode,
	endonym: 'Kreyòl Ayisyen',
	displayValue: 'Haitian Creole',
	raadELLPurpose:
		'Moun kenben konesans yo nan pawol ak mo. Lè ou li istwa sa yo konesans ou ap grandi. Vokabilè ou pral grandi tou, ou ap grandi andirans ou pu lekti, epi ou ka amizew avèk lekti chak jou.',
	raadELLPurposeAudio: '/assets/dist/audio/set_the_purpose_' + languageCode + '.mp3',
	raadELLMindset:
		'These articles are full of knowledge. You will learn new and important things by reading them. You will not know many of the things you read about. That’s great! Reading is one way you can learn new things. And when you learn some new things, it gets easier to learn even more new things! Maybe you will already know some of the things in these articles. That’s great also. When you read more about the things you already know, you will increase your own vocabulary. This will help you to understand new, big ideas. Finally, you will become a stronger reader by reading these articles. You will be able to read for longer periods of time. Happy Reading!',
	raadELLMindsetAudio: '',
	raadELLChooseOne: 'Chwazi youn nan istwa sa yo pu ou li kounya.',
	raadELLChooseOneAudio: '/assets/dist/audio/aad_instructions_' + languageCode + '.mp3',
	raadELLBOKDirectionsLabel: 'Direksyon:',
	raadELLBOKWrite: 'Ekri 2 oubyen 3 bagay ou apran nan istwa ou te li a ke ou vle sonje.',
	raadELLBOKWriteAudio: '/assets/dist/audio/bok_instructions_' + languageCode + '.mp3'
};
